import { FC, useState } from 'react'

import { IconSizes, LockShieldLineIcon } from '@inno-ui/icons'
import { AnimatePresence, motion } from 'motion/react'
import { useTranslation } from 'react-i18next'
import { QuickActionButton } from 'shared/components/QuickActionButton'

import styles from './UsercentricsQuickAction.module.scss'

export const UsercentricsQuickAction: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'usercentrics' })
  const [hovered, setHovered] = useState(false)

  const handleClick = () => {
    window.UC_UI?.showSecondLayer?.()
  }

  return (
    <QuickActionButton
      color='var(--grey-600)'
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label={t('aria_open_privacy_settings')}
    >
      <LockShieldLineIcon size={IconSizes.Size20} color='var(--white)' />

      <AnimatePresence>
        {hovered && (
          <motion.span
            key='label'
            className={styles.label}
            initial={{ width: 0, opacity: 0 }}
            animate={{ width: 'auto', opacity: 1 }}
            exit={{ width: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
          >
            {t('label')}
          </motion.span>
        )}
      </AnimatePresence>
    </QuickActionButton>
  )
}
